import type {
  StorageLocationWriteData,
  StorageLocationDetailsResponse,
} from 'src/apis/storage/types';
import { useAxios } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

type RequestOptions = {
  url: string;
  data: StorageLocationWriteData;
};

export function useStorageLocationCreate() {
  return useAxios(
    (axios, baseConfig, { url, data }: RequestOptions) =>
      axios.request<StorageLocationDetailsResponse>({
        ...baseConfig,
        method: 'POST',
        url,
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isConstraintViolation(error)) {
          return error;
        }
        throw error;
      },
    }
  );
}

export type StorageLocationCreateRequest = ReturnType<
  typeof useStorageLocationCreate
>;
